import React from 'react';
import { Bar, Line, Radar } from 'react-chartjs-2';
import { defaultIChartJsData } from '../models/chart/chart-data';
import { ChartType } from '../models/chart/chart-type';
export class StandarChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data || defaultIChartJsData(),
            title: props.title || '',
            type: props.type
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            data: props.data || defaultIChartJsData(),
            title: props.title || '',
            type: props.type
        });
    }
    render() {
        const options = {
            scale: {
                ticks: { beginAtZero: true },
            },
            title: {
                display: true,
                text: this.props.title
            }
        };
        const data = {
            labels: this.state.data.Labels,
            datasets: (this.state.data.Datasets || []).map(o => ({
                backgroundColor: o.BackgroundColor,
                borderColor: o.BorderColor,
                borderWidth: o.BorderWidth,
                data: o.Data,
                label: o.Label
            }))
        };
        switch (this.state.type) {
            case ChartType.VerticalBar:
                return React.createElement(Bar, { data: data, options: options });
            case ChartType.Radar:
                return React.createElement(Radar, { data: data, options: options });
            case ChartType.Line:
                return React.createElement(Line, { options: options, data: data });
            default:
                return React.createElement("div", null, "Chart type not supported");
        }
    }
}
